import { getOption } from "../../lib/product-utils";

const TRUE = "true";

function getVariant(variants, { size, option }) {
  let selectedVariant = variants[0];
  if (size && option) {
    selectedVariant = variants.find(
      (variant) => getOption(variant, option)?.toLowerCase() === size.toLowerCase()
    );
  }

  if (!selectedVariant) {
    selectedVariant = variants[0];
  }

  return selectedVariant;
}

// Get the initial variant
// We want to avoid showing the wait list on first view
function getFirstAvailableVariant(variants, { size, option }) {
  const firstAvailableVariant = variants.find((variant) => variant.availableForSale);

  if (size && option) {
    const variant = variants.find(
      (variant) =>
        variant.availableForSale && getOption(variant, option)?.toLowerCase() === size.toLowerCase()
    );

    // If the variant selected is sold out
    if (!variant && firstAvailableVariant) return firstAvailableVariant;
    // If everything is sold out
    if (!variant && !firstAvailableVariant) return variants[0];
    // If the variant selected is NOT sold out
    return variant;
  }

  if (!firstAvailableVariant) {
    return variants[0];
  }

  return firstAvailableVariant;
}

// `waitlist=true`
// We want to show the waitlist if 'waitlist' query is true
// This is needed because there are two different possible
// behaviours depending on what page the user is coming from:
// 1. Show waitlist for selected size
// 2. Show first available size instead of waitlist
export function getInitialVariant(variants, router) {
  const urlParams = new URLSearchParams(router.asPath);
  const { waitlist } = router.query;
  if (waitlist === TRUE) {
    return getVariant(variants, {
      size: urlParams.get("size") ?? null,
      option: "size",
    });
  }

  return getFirstAvailableVariant(variants, {
    size: urlParams.get("size") ?? null,
    option: "size",
  });
}
